// removed by extract-text-webpack-plugin
module.exports = {"button":"style__button__2ikOm","inline":"style__inline__1fnTs","inline_primary":"style__inline_primary__1Q6Ji","fullWidth":"style__fullWidth__3gq62","primary":"style__primary__1i20Z","disabled":"style__disabled__2Fml5","small":"style__small__2uUPM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/button/style.scss
// module id = 638
// module chunks = 0